/* eslint-disable react/prop-types */
import styled, { css } from 'styled-components'

export const StyledBox = styled.div`
    align-items: center;
    background: ${({ theme }) => theme.white || 'white'};
    border: 1px solid #dddee1;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 13px 20px 0;
    padding: 4px 12px 4px 12px;
    width: fit-content;
`

export const StyledBoxTitle = styled.div`
    font-size: 11px;
    font-family: ${({ theme }) => theme['font-semibold']};
    color: #28334a;
    text-transform: uppercase;
    margin-bottom: 10px;
`

export const StyledBoxContent = styled.div`
    font-size: 24px;
    font-family: ${({ theme }) => theme['font-regular']};
    color: ${({ theme }) => theme.gray || 'gray'};
    margin-bottom: 10px;
`

export const Title = styled.h1`
    font-size: 26px;
    font-family: ${({ theme }) => theme['font-semibold']};
    color: ${({ theme }) => theme['text-color'] || '#364159'};
    line-height: 28px;
`

export const Header = styled.div`
    background-color: #fff;
    height: 44px;
    padding: 0 15px;

    div {
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        font-size: 11px;
        line-height: 44px;
        letter-spacing: normal;
        color: #868695;
        text-transform: uppercase;

        &.selected {
            color: ${({ theme }) => theme['text-color'] || '#364159'};
        }
    }
`

export const Columns = styled.div`
    display: flex;
    align-items: center;
`

export const Empty = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50%;
    font-size: 14px;
    margin-top: 100px;
`

export const ListContainer = styled.div`
    height: 100%;
`

export const RegularIcon = styled.i`
    font-size: ${({ fontSize = 11 }) => fontSize}px;
    color: ${({ color, theme }) => color || theme.icons || '#868695'};
`

export const ButtonIcon = styled.i`
    font-size: ${({ fontSize = 16 }) => fontSize}px;
    color: ${({ theme }) => theme['link-color'] || '#37a3ef'};
    cursor: pointer;
    text-align: center;

    ${({ fontWeight }) =>
        fontWeight &&
        css`
            font-weight: ${fontWeight};
        `}
`

export const Column = styled.div`
    flex: 1;
    font-size: 12px;
    color: #364159;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ inactive }) => (inactive ? 0.6 : 1)};

    > .alarm-card-options {
        width: 80%;

        ${ButtonIcon} {
            width: 100%;
        }
    }
`
